import api from '@/api';
import { useMutation, useQueryClient } from '@tanstack/vue-query';

export async function uploadUserCv(user_uuid: string, file: File) {
  const formData = new FormData();
  formData.append('cv', file, file.name);

  return await api({
    method: 'POST',
    url: `/user/${user_uuid}/cv`,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  });
}

export function useUploadUserCvMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ user_uuid, file }: { user_uuid: string; file: File }) =>
      uploadUserCv(user_uuid, file),
    onSuccess: () => {
      // Invalidate user query to refetch updated CV info
      queryClient.invalidateQueries({ queryKey: ['me'] });
    },
  });
}
